/* unplugin-vue-components disabled */import script from "./page-header.vue?vue&type=script&setup=true&lang=js"
export * from "./page-header.vue?vue&type=script&setup=true&lang=js"

import "./page-header.vue?vue&type=style&index=0&id=60cd35bc&lang=less&scoped=true"
import "./page-header.vue?vue&type=style&index=1&id=60cd35bc&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60cd35bc"]])

export default __exports__